import { Component, OnInit } from '@angular/core';
import { AgentBankBranchHandler } from './agent-bank-brank.handler';
import { AgentService } from '../services/agent.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-bank-branch',
  templateUrl: './agent-bank-branch.component.html',
  styleUrls: ['./agent-bank-branch.component.scss'],
})
export class AgentBankBranchComponent extends AgentBankBranchHandler {
  constructor(public service: AgentService, public router: Router, public settingService: SettingService) {
    super(service, router, settingService);
  }

  ngOnInit() {
    // super.ngOnInit();
  }
}
